let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bGKBI")).then(() => parcelRequire('fu8a0'));